import { HttpContextToken } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  isLoading = signal<boolean>(false); // Signal for tracking loading state  

  show() {
    this.isLoading.set(true);
  }

  hide() {
    this.isLoading.set(false);
  }
  
}

export const SKIP_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
